import { FC } from 'react'
import { Layout } from 'components/Layout'
import { TodayStockTemplate } from 'components/Templates'

const ReleasedStock: FC = () => {
  return (
    <Layout headline={'在庫の増減と通知'} iconPath={'/icon/white/stock.svg'} title={'本日の在庫を編集する | 販売中'}>
      <TodayStockTemplate page={'released'} />
    </Layout>
  )
}

export default ReleasedStock
